import React, { ChangeEvent } from 'react';

import styles from './inline-text-area.module.scss';
interface InlineTextAreaProps {
  value?: string;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onSubmit?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  errorMessage?: string | undefined | any;
  placeholder?: string | null;
  name?: string;
  defaultValue?: string;
  rows?: number;
  cols?: number;
  className?: string;
}

export const InlineTextArea: React.FC<InlineTextAreaProps> = React.forwardRef<
  HTMLTextAreaElement,
  InlineTextAreaProps
>(
  (
    {
      value,
      onChange,
      onSubmit,
      errorMessage,
      placeholder,
      name,
      rows = 4,
      cols = 50,
      defaultValue,
      className,
    },
    ref,
  ) => {
    const handleOnKeyDown = async (e: any) => {
      if (e.key === 'Enter') {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          document.body.tabIndex = 0;
          onSubmit && (await onSubmit(e));
          document.body.focus();
        }
      }
    };

    return (
      <div className={styles['container']}>
        <textarea
          className={`${styles['input']} ${className ?? ''}`}
          ref={ref}
          value={value}
          onChange={onChange}
          data-error={!!errorMessage}
          name={name}
          placeholder={placeholder || ''}
          onKeyDown={handleOnKeyDown}
          onBlur={onSubmit}
          rows={rows}
          cols={cols}
          defaultValue={defaultValue}
          onClick={(e) => e.stopPropagation()}
        />

        {errorMessage && <span className={styles['error']}>{errorMessage}</span>}
      </div>
    );
  },
);

InlineTextArea.displayName = 'InlineTextArea';
